import { render, staticRenderFns } from "./MypageDestinationsPage.vue?vue&type=template&id=3f4dd28f&"
import script from "./MypageDestinationsPage.vue?vue&type=script&lang=js&"
export * from "./MypageDestinationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports